module.exports = __webpack_public_path__ + "img/business-scope.72ae0546.png";